export const CONFIG = {
  "hashKey": "dw3o292@93",
  "apiUrl": "https://api.shypes.com",
  "mediaUrl": "https://media.shypes.com",
  "socketServerUrl": "https://socket.shypes.com",
  "enableSocket": true,
  "socketMode": "websocket",
  "baseDomain": "circleplug.com"
};
